import React from 'react';

import Table from '../Table';

import { createAchCheckBillPaymentStatus } from '../../helpers/createAchCheckStatus';
import createBillPaymentTableCell from '../../helpers/tables/createBillPaymentPayeeTableCell';
import createBillsListTableCell from '../../helpers/tables/createBillsListTableCell';
import useUserRole from '../../hooks/useUserRole';

export default function BillPaymentsTable({
  isFetching,
  billPayments,
  noTitle,
  //  isLenderPage,
  isBillPaymentsPage,
}) {
  const { isLender } = useUserRole();

  const cols = [
    {
      title: 'Date',
      keys: ['date'],
      type: 'date',
    },
    {
      title: 'Payee',
      keys: ['payee_object'],
      format: createBillPaymentTableCell,
      wrapText: true,
    },
    {
      title: 'Source',
      keys: ['source'],
    },
    {
      title: 'Payment Status',
      keys: ['123'],
      format: (value, row) => {
        return createAchCheckBillPaymentStatus(row);
      },
      type: 'badge',
      badgeColor: (value) => {
        switch (value) {
          case 'not started':
          case 'Not started':
          case 'scheduled':
          case 'Scheduled':
          case 'pending':
          case 'Pending':
          case 'delivered':
          case 'Delivered':
            return 'amber';
          case 'cashed':
          case 'Cashed':
          case 'paid':
          case 'Paid':
            return 'emerald';
          default:
            return 'slate';
        }
      },
    },
    {
      title: 'Reference',
      keys: ['reference'],
    },
    {
      title: 'Amount',
      keys: ['amount'],
      type: 'currency',
    },
    {
      title: 'Status',
      type: 'badge',
      badgeColor: (value) => {
        switch (value) {
          case 'applied':
            return 'emerald';
          case 'void':
            return 'slate';
          case 'unapplied':
          case 'partial':
            return 'rose';
          default:
            return 'slate';
        }
      },
      keys: ['status'],
      link: (row) => {
        if (isLender) {
          return null;
        }

        return `/bill-payments/${row.id}`;
      },

      /* type: 'button',
      label: (row) => {
        if (row.status === 'void') {
          return 'void';
        }

        return row.status === 'applied' ? 'Applied' : 'Apply';
      },
      buttonVariant: (row) => {
        return row.status === 'applied' || row.status === 'void'
          ? 'transparent'
          : '';
      },
      onClick: (row) => {
        if (loanId) {
          navigate(`/loans/${loanId}/bill-payments/${row.id}?tab=Bill Payment`);
        } else {
          navigate(`/bill-payments/${row.id}`);
        }
      }, */
    },
    {
      title: 'Paid from',
      keys: ['paid_from'],
      isColumnHidden: !isBillPaymentsPage,
    },
    {
      title: 'Paid to',
      keys: ['paid_to'],
      isColumnHidden: !isBillPaymentsPage,
    },
    {
      title: 'Bills',
      keys: ['bills'],
      format: createBillsListTableCell,
      isColumnHidden: isBillPaymentsPage,
    },
    /* {
      title: 'Statement',
      keys: ['document_id'],
      type: 'button',
      label: () => 'Download Statement',
      isVisible: (row) => !!row.document_id,
      isColumnHidden: isBillPaymentsPage,
      onClick: async (row) => {
        try {
          await downloadDocument(
            row.document_id,
            `${row._document?.private_document?.name}.pdf`
          );
        } catch (error) {
          console.log(error);
          showToast({
            text: error?.response?.data?.message || 'Something went wrong',
            type: 'error',
          });
        }
      },
    }, */
  ];

  const table = (
    <Table
      cols={cols}
      //  rows={billPayments?._bill_payments}
      rows={billPayments}
      isFetching={isFetching}
      minHeight={565}
      title={noTitle ? 'Bill Payments' : ''}
    />
  );

  return noTitle ? (
    table
  ) : (
    <div className="p-7 col-span-full sm:col-span-6 xl:col-span-4 bg-white dark:bg-slate-800 shadow-lg rounded-sm border border-slate-200 dark:border-slate-700 mb-10">
      <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-6">
        Bill Payments
      </h2>
      {table}
    </div>
  );
}
